// extracted by mini-css-extract-plugin
module.exports = {"fullBanner":"FullBannerVideo_fullBanner__1ezR1","control":"FullBannerVideo_control__1tVD1","pau":"FullBannerVideo_pau__FQf-D"};